import './activismPhotoArchive.css'

import action2024 from '../../../../assets/img/activism/Acción en Punto Rojo Barcelona 8M_Marzo2024.jpeg'
import action2025 from '../../../../assets/img/activism/Acción en Punto Rojo Barcelona 8M_Marzo 2025.jpg'
import action2026 from '../../../../assets/img/activism/Acción en Punto Rojo Barcelona 8M_Marzo 2026.jpeg'
import menarquia2026 from '../../../../assets/img/activism/Acción por el Día Mundial de la Menarquia_28 de octubre 2026.jpeg'
import cartel2025 from '../../../../assets/img/activism/Cartel hecho por Rocío Ahumada para el Punto Rojo Barcelona_ Agosto 2025.png'

const activismPhotos = [
  {
    image: action2024,
    alt: 'Acción en Punto Rojo Barcelona 8M Marzo 2024',
    caption: 'Acción en Punto Rojo Barcelona. 8M, marzo 2024.'
  },
  {
    image: action2025,
    alt: 'Acción en Punto Rojo Barcelona 8M Marzo 2025',
    caption: 'Acción en Punto Rojo Barcelona. 8M, marzo 2025.'
  },
  {
    image: action2026,
    alt: 'Acción en Punto Rojo Barcelona 8M Marzo 2026',
    caption: 'Acción en Punto Rojo Barcelona. 8M, marzo 2026.'
  },
  {
    image: menarquia2026,
    alt: 'Acción por el Día Mundial de la Menarquia. MenstruActivismo convocado por Cintia de @la_menstruaccion. 28 de octubre de 2026.',
    caption: 'Acción por el Día Mundial de la Menarquia. MenstruActivismo convocado por Cintia de @la_menstruaccion. 28 de octubre de 2026.'
  },
  {
    image: cartel2025,
    alt: 'Cartel hecho por Rocío Ahumada para el Punto Rojo Barcelona Agosto 2025',
    caption: 'Cartel hecho por Rocío Ahumada para el Punto Rojo Barcelona. Agosto 2025.'
  }
]

const ActivismPhotoArchive = () => (
  <section className='activism-photo-archive' aria-labelledby='activism-photo-archive-title'>
    <div className='activism-photo-archive__header'>
      <div className='activism-photo-archive__intro'>
        <span className='activism-photo-archive__eyebrow'>Memoria y acción colectiva</span>
        <h2 id='activism-photo-archive-title' className='activism-photo-archive__title'>
          Selección de fotos de intervención en el espacio público
        </h2>
        <p className='activism-photo-archive__description'>
          Recogemos imágenes de las acciones que han visibilizado el ciclo menstrual, la salud y los derechos en la calle.
        </p>
      </div>
    </div>
    <div className='activism-photo-archive__gallery'>
      {activismPhotos.map((photo) => (
        <article className='activism-photo-archive__item' key={photo.alt}>
          <img src={photo.image} alt={photo.alt} />
          <div className='activism-photo-archive__overlay'>{photo.caption}</div>
        </article>
      ))}
    </div>
  </section>
)

export default ActivismPhotoArchive
